<template>

<div class="bg-secondary py-5">

        <inertia-head title="Reset Password">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 360px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-header border-0">{{ __('Reset Password') }}</div>

                        <div class="card-body">

                            <form @submit.prevent="form.post(route('password.update'))">
                                <text-input type="email" :floating="true" label="email" v-model="form.email" :error="form.errors.email" autocomplete="email" autofocus />
                                <text-input type="password" :floating="true" label="password" v-model="form.password" :error="form.errors.password" />
                                <text-input type="password" :floating="true" label="password_confirmation" v-model="form.password_confirmation" :error="form.errors.password_confirmation" />
                                <submit-button :label="__('Reset Password')" child-class="w-100" />
                            </form>           

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        layout: SlimLayout,
        props: [
            'token',
            'email',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    token: this.token,
                    email: this.email,
                    password: null,
                    password_confirmation: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
        computed: {
        },
    }
</script>
